module.exports = __webpack_public_path__ + "img/chairs.82e23389.jpeg";